module.exports = __webpack_public_path__ + "img/11069866_L.48641698.png";